import { environment } from '../../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular
    .module('app')
    .factory('ClientProfileProductSettingService', ClientProfileProductSettingService);

  ClientProfileProductSettingService.$inject = [
    'RestResource',
    'UtilService',
    '$translate',
    '$filter',
    'ModalWindowConfirmService',
  ];

  function ClientProfileProductSettingService(
    RestResource,
    UtilService,
    $translate,
    $filter,
    ModalWindowConfirmService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'client_profiles';

    var service = {
      saveProductSettings: saveProductSettings,
      deleteProductSettings: deleteProductSettings,
      setProductSettings: setProductSettings,
      groupSettingsByProduct: groupSettingsByProduct,
      unGroupSettingsByProduct: unGroupSettingsByProduct,
    };

    return service;

    ////////////////

    function saveProductSettings(productSettings, clientProfileId, clientProfileSeasonId) {
      var url = apiUrl + '/' + clientProfileId + '/client_profile_seasons/' + clientProfileSeasonId;
      url += '/client_profile_product_settings/update_settings';

      function success(response) {
        utils._successMsg($translate('PRODUCT_SETTING_UPDATED'));

        return response.data;
      }
      function failure(response) {
        utils._errorMsg(response.data.error);

        return false;
      }

      return RestResource.request(
        'put',
        url,
        { product_settings: productSettings },
        success,
        failure
      );
    }

    function deleteProductSettings(
      productSettings,
      clientProfileId,
      clientProfileSeasonId,
      successCallback
    ) {
      var modalParams = {
        mode: 'danger',
        title: 'SURE_TO_DELETE_PRODUCT_SETTING',
      };

      var confirmCallback = function () {
        function success() {
          utils._successMsg($translate('SETTING_DELETED'));

          return successCallback();
        }

        function failure(response) {
          utils._errorMsg(response.data.error);

          return false;
        }

        var url =
          apiUrl + '/' + clientProfileId + '/client_profile_seasons/' + clientProfileSeasonId;
        url += '/client_profile_product_settings/delete_settings';

        return RestResource.request(
          'put',
          url,
          { product_settings: productSettings },
          success,
          failure
        );
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }

    function setProductSettings(clientProfileProductSettings, priceLists) {
      clientProfileProductSettings = clientProfileProductSettings || [];

      var settingsByProduct = groupSettingsByProduct(clientProfileProductSettings);

      var productSettings = [];
      settingsByProduct.forEach(function (settingByProduct) {
        var settingsByPriceList = [];

        priceLists.forEach(function (priceList) {
          var settingId,
            percentage = 0;

          for (var i = 0; i < settingByProduct.settingsByPriceList.length; i++) {
            var setting = settingByProduct.settingsByPriceList[i];

            if (setting.price_list_id === priceList.id) {
              settingId = setting.id;
              percentage = setting.percentage;
              break;
            }
          }

          var priceListSetting = {
            product_type: settingByProduct.product_type,
            percentage: percentage,
            product_id: settingByProduct.product_id,
            price_list_id: priceList.id,
            id: null,
          };

          // Exists
          if (settingId) {
            priceListSetting.id = settingId;
          }

          settingsByPriceList.push(priceListSetting);
        });

        var setting = {
          product: settingByProduct.product,
          product_type: settingByProduct.product_type,
          settingsByPriceList: settingsByPriceList,
        };

        productSettings.push(setting);
      });

      return productSettings;
    }

    /* Ex: {
                product: { id: value, name: value }, 
                settingsByPriceList: [{ key: value }, { key: value }]
               }
        */
    function groupSettingsByProduct(productSettings) {
      var settingsByProduct = [];
      var identifier;

      // Group settings by product
      productSettings.forEach(function (productSetting) {
        identifier = productSetting.product_id;

        if (!settingsByProduct[identifier]) {
          settingsByProduct[identifier] = [];
        }

        settingsByProduct[identifier].product = productSetting.product;

        settingsByProduct[identifier].product_type = productSetting.product_type;
        settingsByProduct[identifier].product_id = productSetting.product_id;
        settingsByProduct[identifier].settingsByPriceList =
          settingsByProduct[identifier].settingsByPriceList || [];
        settingsByProduct[identifier].settingsByPriceList.push({
          id: productSetting.id,
          percentage: productSetting.percentage,
          price_list_id: productSetting.price_list_id,
        });
      });

      return utils.removeKeyFromArrayObject(settingsByProduct);
    }

    // In case whe want to save in bulk (embeds_many)
    function unGroupSettingsByProduct(productSettings) {
      if (!productSettings) {
        return;
      }

      var settingsByProduct = [];

      productSettings.forEach(function (productSetting) {
        productSetting.settingsByPriceList.forEach(function (priceListSetting) {
          settingsByProduct.push({
            id: priceListSetting.id,
            product_type: priceListSetting.product_type,
            percentage: priceListSetting.percentage,
            product_id: priceListSetting.product_id,
            price_list_id: priceListSetting.price_list_id,
          });
        });
      });

      return settingsByProduct;
    }
  }
})();
